import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import LegalDocument from "../../entity/user/LegalDocument";

const SERVICE = "service-user";
const ENTITY = "legal_documents";

export default function () {
    const {findOneBy, findAllBy, create, update} = useApi();
    const state = useSelector;
    const newInstance = data => new LegalDocument(data);

    return {
        findOneById(id) {
            return {
                select() {
                    const result = state(state => state.api?.user?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    findOneBy(SERVICE, ENTITY, "id", id, newInstance, "entrepreneur");
                }
            }
        },
        findAllByCompanyId(id) {
            return {
                select() {
                    const result = state(state => state.api?.user?.[ENTITY]?.filter(ld => ld?.getCompanyId() == id));

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    findAllBy(SERVICE, ENTITY, "company_id", id, newInstance, "entrepreneur");
                }
            }
        },
        findAllByCompanyIdToProvide(id) {
            return {
                select() {
                    const result = state(state => state.api?.user?.[ENTITY]?.filter(ld => ld?.getCompanyId() == id && ld?.getStatus() === LegalDocument.STATUS_WAITING_FOR_PROVIDE));

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    findAllBy(SERVICE, ENTITY, "company_id", id, newInstance, "entrepreneur");
                }
            }
        },
        async update(id, property, payload) {
            return update(SERVICE, ENTITY, id, property, payload, newInstance, "entrepreneur");
        }
    }
}